// extracted by mini-css-extract-plugin
export default {"createProduct":"create-product_createProduct__PG9Ig","header":"create-product_header__IWuFV","field":"create-product_field__W5+ek","actions":"create-product_actions__R9rOK"};